<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    <span class="float-left ">Version 1.2 
      Copyright &copy; {{currentDate | date: 'yyyy'}} <a href="https://www.detroitlions.com/" target="_blank">Detroit Lions</a>
      <span class="d-none d-sm-inline-block">, ALL RIGHTS RESERVED.</span>
    </span>
    <span class="float-right ">Powered by
      <a href="https://simpello.com" target="_blank">Simpello</a>
    </span>
  </p>
</footer>
<!--Footer Ends-->